<template>
  <form>
    <div class="box">
      <nav class="level">
        <div class="level-left">
          <h3 class="subTitle">{{title}}</h3>
        </div>
      </nav>
      <section class="row">
        <b-field class="col-md-5 col-lg-4 mb-3">
          <b-input placeholder="Digite o nome da segmentação" v-model="segmentName" v-if="selectedModel === 'manual'"></b-input>
        </b-field>
      </section>
      <section>
        <b-field class="searchSegments mb-5">
          <InputSelect 
            :currentValue="undefined"
            name="model"
            :items="models"
            label="Selecione o Modelo"
            @set="set" >
          </InputSelect>
        </b-field>
      </section>
      <section>
        <input type="file" accept='.xlsx, .xls' @change="onChange"  :disabled="!!selectedModel ? disabled : ''" />
      </section>
    </div>
    <div :class="showContent ? 'hidden-btn' : ''" class="level-right pt-4 pb-5">
      <Button @event="back" name="Voltar" />
      <Button class="validate" :name="submitLabel" @event="submit" />
    </div>
  </form>
</template>

<script>
/* eslint-disable no-unreachable */

import { mapState } from 'vuex'
import { importSegment } from '@/services/segments'
import { InputSelect, Button } from '@/components/form'

const importDataLabel = () => 'Importar'

export default {
  name: 'Importer',
  components: {
    InputSelect,
    Button,
  },
  props: {
    title: {
      type: String,
      default: () => ''
    },
    clone: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    data: null,
    file: null,
    backRoute: '/',
    loading: true,
    selectedSheet: null,
    submitLabel: importDataLabel(),
    models: [
      {id: 'manual', name: 'Manual'},
      {id: 'buse', name: 'Modelo Planilha Buse'},
      {id: 'transfacil', name: 'Modelo 3 - Transfácil - Manteve'},
      {id: 'zero', name: 'Modelo Frequência Zero'},
    ],
    segmentName: '',
    selectedModel: null,
    selectedPartner: '',
    showContent: false,
  }),
  async created () {
  },
  computed: {
    ...mapState(['configurations'])
  },
  methods: {
    async set({ name, item }) {
      if (name === 'model') {
        this.selectedModel = item.id
      }
    },
    onChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
      const reader = new FileReader()
      reader.readAsDataURL(this.file)
      reader.onload = (e) => {
        this.data = {
          file: e.target.result
        }
      }
    },
    async submit() {
      this.showContent = false

      if (this.validates()) {
        try {
          await importSegment(this.selectedModel, {'data': { ...this.data, segmentName: this.segmentName }})
          this.$swalModal(
            'Sucesso',
            'Segmentação clonada com sucesso!',
            'success'
          )
          this.showContent = false
          this.back()
        } catch (error) {
          this.$swalModal(
            'Erro',
            'Não foi possível clonar essa segmentação!',
            'error'
          )
        }
      }
    },
    back() {
      this.$router.push('/')
    },
    validates() {
      if(this.selectedModel === 'manual' && !this.segmentName){
        this.$swalModal(
          'Erro',
          'Escreva um nome para o segmento!',
          'error'
        )
        return false;
      }
      if (!this.selectedModel) {
        this.$swalModal(
          'Erro',
          'Selecione o modelo da importação!',
          'error'
        )
        return false;
      }
      if(!this.file) {
        this.$swalModal(
          'Erro',
          'Insira a planilha a ser importada!',
          'error'
        )
        return false;
      }
      return true
    },
  }
}
</script>

<style lang="scss">
.inputSwitchDiv{
  position: relative;
  @media (max-width: 992px){
    width: 200px;
    height: 100px;
  }
  div{
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.card-select{
  min-height: 300px;
  min-width: 234px;
  border: 1px solid #2d9cdb;
}
.swit{
  display: flex;
  align-items: center;
}
.box{
  margin-top: 24px;
}
.boxCard{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-width: 100%;
  overflow: hidden;
}
.overflow-y {
  overflow-y: auto;
}
.subTitle{
  font-weight: 500;
  font-size: 14px;
  color: #6D6D77;
}
.searchSegments{
    width: 26%
}
.validate:disabled {
  color: #363636 !important;
}
.card {
  position: relative;
  .next-btn {
    position: absolute;
    margin: auto;
    right: 0;
    left: 0;
    top: 20rem;
    bottom: 0;
    transform: rotate(90deg)
  }
  // &-filter:after{
  //   @media (min-width: 992px){
  //     background-color: #2d9cdb;
  //     content: '';
  //     display: block;
  //     position: absolute;
  //     top: 50%;
  //     transform: translateY(-50%);
  //     height: 2px;
  //     right: -250px;
  //     width: 250px;
  //     pointer-events: none;
  //   }
  // }
}
.boxCard>div:nth-last-child(-n+2)>.fixed {
  display: none !important;
}
.boxCard>div:nth-last-child(-n+2)>div>.card-filter:after{
  display: none;
}
.dropdown-menu {
  top: -18.4rem;
  padding: 0px;
}
.datepicker {
  .datepicker-table {
    .datepicker-body {
      .datepicker-cell.is-selected {
        background-color: #2D9CDB !important;
      }
      .datepicker-cell.is-today {
        border: solid 1px #2D9CDB !important;
      }
    }
  }
  .has-text-primary {
    color: #2D9CDB !important;
  }
}
.control .has-icons-left .is-clearfix {
  .input {
    padding-left: 0 !important;
  }
}
.hidden-btn {
  visibility: hidden;
}
.hidden-inputs {
  display: none !important;
}
.card-filter {
  min-height: 25rem !important;
  position: relative;
  .titleCard {
    position: absolute;
    top: 12px;
  }
}
.filter-card {
  min-height: 25rem !important;
}
.group {
  &:nth-child(odd) {
	background-color:#ffffff;
	}
	&:nth-child(even) {
	background-color:#f1f1f1b8;
	}
  position: relative;
  padding: 0 20px;
  .group-content {
    overflow-x: scroll;
    margin-top: 2rem;
    min-height: 10rem;
  }
  .group-items {
    display: flex;
    flex-wrap: nowrap;
  }
  .aggregator {
    .input-switch {
      min-width: 120px;
      white-space: nowrap;
      padding-left: 5px;
      &:first-child {
        border-radius: 5px 0 0 5px;
      }
      &:last-child {
        border-radius: 0 5px 5px 0;
      }
    }
  }
  .aggregator-type {
    .input-switch {
      width: 60px;
    }
  }
  .group-header {
    display: flex;
    justify-content: start;
    position: absolute;
    left: 0;
    top: 8px;
    width: 100%;
    .header-content {
      display: flex;
      justify-content: flex-end;
    }
    .btn-close {
      cursor: pointer;
        right: 0;
    }
  }
  .empity-group {
    display: flex;
    justify-content: center;
    position: absolute;
    right: 0;
    left: 0;
    top: 80px;
    color: #2D9CDB;
    font-weight: 600;
  }
}
.and-btn {
  width: 100%;
  align-items: center;
}
.fixed {
  width: 100%;
  position: relative;
  height: 80px;
  &:before{
    content: '';
    margin: auto;
    top:0;
    right: 0;
    left: 0;
    display: block;
    background-color: #2D9CDB;
    position: absolute;
    height: 53px;
    width: 2px;
    overflow: hidden;
  }
  .circle {
    position: absolute;
    margin: auto;
    top:0;
    bottom: 0;
    right: 0;
    left: 0;
    cursor: default;
    img {
      cursor: default;
    }
  }
  img {
    width: 20px;
    transform: rotate(270deg);
  }
}
@media(max-width: 768px) {
  .aggregator {
    width: 180px !important;
    .input-switch {
      min-width: 80px !important;
    }
  }
  .group-header {
    right: 31px !important;
    top: 3px !important;
  }
  .group {
    .empity-group {
      left: 80px;
    }
    .btn-close {
      cursor: pointer;
        right: -20px !important;
    }
  }
}
</style>